import React, { useMemo } from "react";
import { CardTotalRow } from "./CardTotalRow";
import { CartEmptyMesg } from "./CartEmptyMesg";
import { CartItemRows } from "./CartItemRows";
import { useCartQuery } from "../hooks/useCart";
interface CartProps {
  onGoToCart?: () => void;
}

const Cart: React.FC<CartProps> = ({ onGoToCart }) => {
  const { data } = useCartQuery();
  const cartItems = useMemo(() => data ?? [], [data]);

  return (
    <div className="relative mx-auto w-[calc(100vw_-_3rem)] overflow-hidden rounded-[0.9375rem] border border-[#DCDCDC] bg-white pt-2 shadow-sm sm:w-[25rem]">
      {cartItems.length > 0 ? (
        <>
          <CartItemRows cartItems={cartItems} />
          <CardTotalRow cartItems={cartItems} onGoToCart={onGoToCart} />
        </>
      ) : (
        <CartEmptyMesg />
      )}
    </div>
  );
};

export default Cart;
